import { type AxiosRequestConfig, type AxiosResponse } from 'axios';
import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { type CreateTracking } from '@avanta/shared/types/tracking';

const API_URL = `${BASE_URL}tracking`;

export type TrackingServiceTypes = {
  createTracking: (
    userId: string | number,
    trackingBody: CreateTracking,
    config?: AxiosRequestConfig
  ) => Promise<AxiosResponse<void>>;
  createTrackingByEmail: (
    email: string,
    trackingBody: CreateTracking,
    config?: AxiosRequestConfig
  ) => Promise<AxiosResponse<void>>;
};

export const TrackingService: TrackingServiceTypes = {
  createTracking: async (userId, trackingBody, config) =>
    service.post(`${API_URL}/${userId}`, trackingBody, config),
  createTrackingByEmail: async (email, trackingBody, config) =>
    service.post(`${API_URL}/byEmail/${email}`, trackingBody, config),
};
